export default function Board() {
    return (

        <div className="divboard3">



            <div className="boards">
                <h2 className="titleboard">Excelência   </h2>

                <h2 className="subboards">Contamos com uma equipe de <strong className="s">profissionais</strong> altamente <strong className="s">qualificados</strong> e comprometidos com entregas de qualidade.</h2>
            </div>
            <div className="boards">
                <h2 className="titleboard">Integridade   </h2>

                <h2 className="subboards">Prezamos pela <strong className="s">responsabilidade</strong> e honestidade. Comprometidos com a <strong className="s">transparência</strong> em nosso trabalho.</h2>
            </div>


        </div>)
}